import React from "react";
import MobilePopup from '../../shared/MobilePopup/MobilePopup';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import { PathwordStore } from '../PathwordStore';
import { isMobile } from 'react-device-detect';
import InstructionsVideo_mp4 from 'url:./videos/Pathword.mp4';
import InstructionsVideo_webm from 'url:./videos/Pathword.webm';

const MobilePathwordInstructions = () => {
  const isOpen = PathwordStore.useState(s => s.instructionsAreOpen);

  const onClose = () => {
    Cookies.set(`${PuzzleNames.Pathword}InstructionsDismissed`, 'true', {
      domain: DOMAIN,
      expires: 365,
    });
    PathwordStore.update(s => {
      s.instructionsAreOpen = false;
      s.isSoftPaused = false;
    });
  };

  return (
    <MobilePopup isOpen={isOpen} onClose={onClose} title="How to Play the Pathword">
      <p>
        Start at the starred square and {isMobile ? 'tap' : 'click'} the grid squares to plot a path for the letters through the grid.
      </p>
      <br/>
      <p>
        Each step of the path will use one letter from the cluetext above the grid, in order.
      </p>

      <br/>

      <ul>
        <li>Each horizontal row must spell a 4-letter word. Columns do <span className="boldText">not</span> need to spell words.</li>
        <li>Consonants can only go in white squares. Vowels can only go in grey squares. (Y counts as a vowel.) </li>
        <li>Valid moves for the next letter are shown with each new step of the path.</li>
        <li>Blue hint letters can only be placed in their assigned spots.</li>
      </ul>

      <video controls autoPlay>
        <source src={InstructionsVideo_webm} type="video/webm" />
        <source src={InstructionsVideo_mp4} type="video/mp4" />
        <p>Your browser does not support HTML5 video elements.</p>
      </video>
    </MobilePopup>
  );
};

export default MobilePathwordInstructions;